import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { setSession } from '../admin/auth';
import { authApi } from '../services/authApi';

const ROLES = [
  { id: 'habitant',    label: 'Habitant·e',     desc: 'Je vis à Cambérène' },
  { id: 'diaspora',    label: 'Diaspora',       desc: 'Originaire de Cambérène' },
  { id: 'commerce',    label: 'Commerce',       desc: 'Référencer mon activité' },
  { id: 'visiteur',    label: 'Visiteur·euse',  desc: 'Découvrir le village' },
];

const Inscription = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    prenom: '',
    nom: '',
    email: '',
    password: '',
    confirm: '',
    role: 'habitant',
    cgu: false,
    newsletter: true,
  });
  const [status, setStatus] = useState({ loading: false, error: null });
  const [showPwd, setShowPwd] = useState(false);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const validate = () => {
    if (!form.prenom.trim() || !form.nom.trim()) return 'Prénom et nom requis.';
    if (!form.email.includes('@')) return 'Email invalide.';
    if (form.password.length < 8) return 'Mot de passe : 8 caractères minimum.';
    if (form.password !== form.confirm) return 'Les mots de passe ne correspondent pas.';
    if (!form.cgu) return 'Acceptez la charte communautaire pour continuer.';
    return null;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) return setStatus({ loading: false, error: err });

    setStatus({ loading: true, error: null });
    try {
      const { token, user } = await authApi.register({
        prenom: form.prenom,
        nom: form.nom,
        email: form.email,
        password: form.password,
      });
      setSession({ token, user });
      navigate(user.role === 'admin' ? '/admin/dashboard' : '/', { replace: true });
    } catch (e2) {
      setStatus({ loading: false, error: e2.message || 'Inscription impossible.' });
    }
  };

  return (
    <main className="auth-page">
      <aside className="auth-side auth-side-alt">
        <div className="auth-side-bg" />
        <div className="auth-side-grain" />
        <div className="auth-side-inner">
          <Link to="/" className="auth-brand">
            <span className="brand-mark"></span>
            <span>Cambérène<small>SN · 221</small></span>
          </Link>
          <div>
            <span className="eyebrow" style={{ color: 'rgba(250,246,238,.7)' }}>Rejoindre la communauté</span>
            <h1 className="auth-side-h" style={{ marginTop: 14 }}>
              Devenez<br /><span className="ital">cambérénois·e numérique.</span>
            </h1>
            <p className="auth-side-p">
              Partagez vos photos, référencez votre commerce, contribuez à l'annuaire et
              recevez l'actualité du village avant tout le monde.
            </p>
            <ul className="auth-side-perks">
              <li><span>•</span> Soumettre photos &amp; portraits</li>
              <li><span>•</span> Référencer votre activité</li>
              <li><span>•</span> Accès à l'agenda complet</li>
              <li><span>•</span> Newsletter mensuelle prioritaire</li>
            </ul>
          </div>
          <div className="auth-side-foot">
            <span>3 200 membres</span>
            <span>· 142 commerces</span>
            <span>· 480 photos</span>
          </div>
        </div>
      </aside>

      <section className="auth-form-side">
        <div className="auth-form-wrap auth-form-wrap-wide">
          <div className="auth-head">
            <span className="eyebrow">Inscription · gratuit</span>
            <h2 className="auth-h">Créer<br /><span className="ital">votre compte.</span></h2>
            <p className="auth-sub">Quelques informations pour commencer. Vous pourrez compléter votre profil plus tard.</p>
          </div>

          <form className="auth-form" onSubmit={onSubmit} noValidate>
            <div className="auth-row">
              <label className="auth-field">
                <span>Prénom</span>
                <input
                  type="text"
                  name="prenom"
                  autoComplete="given-name"
                  placeholder="Aïssatou"
                  value={form.prenom}
                  onChange={onChange}
                  required
                />
              </label>
              <label className="auth-field">
                <span>Nom</span>
                <input
                  type="text"
                  name="nom"
                  autoComplete="family-name"
                  placeholder="N'Diaye"
                  value={form.nom}
                  onChange={onChange}
                  required
                />
              </label>
            </div>

            <label className="auth-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                autoComplete="email"
                placeholder="votre@adresse.email"
                value={form.email}
                onChange={onChange}
                required
              />
            </label>

            <label className="auth-field">
              <span>Mot de passe</span>
              <div className="auth-pwd">
                <input
                  type={showPwd ? 'text' : 'password'}
                  name="password"
                  autoComplete="new-password"
                  placeholder="8 caractères minimum"
                  value={form.password}
                  onChange={onChange}
                  minLength={8}
                  required
                />
                <button
                  type="button"
                  className="auth-pwd-toggle"
                  onClick={() => setShowPwd((s) => !s)}
                >
                  {showPwd ? 'Masquer' : 'Afficher'}
                </button>
              </div>
            </label>

            <label className="auth-field">
              <span>Confirmation</span>
              <input
                type={showPwd ? 'text' : 'password'}
                name="confirm"
                autoComplete="new-password"
                placeholder="Re-saisir le mot de passe"
                value={form.confirm}
                onChange={onChange}
                required
              />
            </label>

            <div className="auth-field">
              <span>Vous êtes…</span>
              <div className="auth-roles">
                {ROLES.map((r) => (
                  <label key={r.id} className={`auth-role ${form.role === r.id ? 'on' : ''}`}>
                    <input
                      type="radio"
                      name="role"
                      value={r.id}
                      checked={form.role === r.id}
                      onChange={onChange}
                    />
                    <b>{r.label}</b>
                    <small>{r.desc}</small>
                  </label>
                ))}
              </div>
            </div>

            <label className="auth-check">
              <input
                type="checkbox"
                name="newsletter"
                checked={form.newsletter}
                onChange={onChange}
              />
              <span>Recevoir la lettre mensuelle de Cambérène</span>
            </label>

            <label className="auth-check">
              <input
                type="checkbox"
                name="cgu"
                checked={form.cgu}
                onChange={onChange}
                required
              />
              <span>
                J'accepte la <a href="#" className="auth-link">charte communautaire</a> et les{' '}
                <a href="#" className="auth-link">conditions d'utilisation</a>.
              </span>
            </label>

            {status.error && <div className="auth-error">{status.error}</div>}

            <button
              type="submit"
              className="btn btn-primary auth-submit"
              disabled={status.loading}
            >
              <span>{status.loading ? 'Création…' : 'Créer mon compte'}</span>
              {!status.loading && <span className="arrow">→</span>}
            </button>
          </form>

          <p className="auth-switch">
            Déjà inscrit ?{' '}
            <Link to="/connexion" className="auth-link">Se connecter →</Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default Inscription;
